import RootState from 'store/state';
import { useSelector } from 'react-redux';

function useAnnouncements() {

    const announcements = useSelector<RootState, RootState["announcements"]>(
        ({ announcements }) => announcements
    )

    return announcements
}

export default useAnnouncements;